export type TMethod =
  | "GET"
  | "POST"
  | "POST-form-urlencoded"
  | "DELETE"
  | "PUT";
export type TPayloadData = {
  id?: string | number;
  filter?: string;
  from?: string;
  to?: string;
  aggregated?: boolean;
  pamCode?: string | number;
  autocompleteKey?: string;
  field?: string;
  value?: string;
  file?: File | string;
  [key: string]:
    | string
    | number
    | boolean
    | object
    | []
    | undefined
    | unknown[]
    | null;
};
export type TQueryParams = {
  [key: string]: string | number | boolean | null | undefined | unknown[];
};
export type TPathParams = {
  [key: string]: string | number | boolean | null | undefined | unknown[];
};
export type TData = {
  pathParams?: TPathParams;
  queryParams?: TQueryParams;
  payloadData?: TPayloadData | TPayloadData[];
};

export type TRequestResponseResult<T> = {
  messages: TErrorMessage[];
  responseCode: TResponseCode;
  isChanged: boolean;
  results: T;
};
export enum TMessageType {
  Error = 1,
  Warning = 2,
  Information = 3,
}
export type TErrorMessage = {
  id: string;
  message: string;
  messageCode: TResponseCode;
  type: TMessageType;
};

export enum TResponseCode {
  OK = 200,
  Error = 700,

  CreatingError = 1000,
  UpdateError = 1001,
  GetError = 1002,
  DeleteError = 1003,

  IdNotExist = 1010,

  CreatingUserError = 2000,
  SetPasswordError = 2001,
  UserNotFound = 2002,
  UpdatingUserError = 2003,
  RoleAlreadyExist = 2004,
  UserAlreadyExistInDb = 2005,
  UserAlreadyExistInIdentityServer = 2006,
  PasswordIsRequired = 2007,

  WatermeterAlreadyExist = 3000,
  WatermeterAlreadyInstalled = 3001,
  IdentifierIdExist = 3002,
  ApartmentNotExist = 3003,
  CityNotExist4Jurisdiction = 3004,
  ProvinceNotExist4Jurisdiction = 3005,
  WaterMeterIsNot4Customer = 3006,
  WatermeterNotAssigned2WaterSubscriber = 3007,
  WatermeterAlreadyAssigned2WaterSubscriber = 3008,

  FetchDataFromLoraServerError = 4000,
  ProcessDataError = 4001,
}
